var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 17.829,
  height: 28.414,
  viewBox: "0 0 17.829 28.414"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_20775",
  "data-name": "Rectangle 20775",
  width: 6.268,
  height: 2.478,
  fill: "none"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "cut-off-power-when-low-battery",
  transform: "translate(3100.414 3769)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_31620",
  "data-name": "Group 31620"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_31635",
  "data-name": "Group 31635",
  transform: "translate(10 187)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_31628",
  "data-name": "Group 31628",
  transform: "translate(-3108 -3956)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_31631",
  "data-name": "Group 31631"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_44147",
  "data-name": "Path 44147",
  d: "M15,8.806c-.2.212-.395.429-.6.631a.358.358,0,0,1-.219.059c-.195.008-.39,0-.586,0-.256,0-.343-.089-.344-.343,0-.493,0-.985,0-1.478v-.17h-.5V7.67q0,1,0,1.99c0,.251-.083.337-.331.338q-3.544,0-7.087,0a.368.368,0,0,1-.338-.186c-.263-.4-.536-.8-.8-1.207a.22.22,0,0,0-.214-.113c-.366.005-.732,0-1.1,0-.31,0-.382-.071-.382-.377,0-.448,0-.9,0-1.357H2V6.92c0,.415,0,.829,0,1.244,0,.252-.08.33-.334.332s-.537,0-.805,0S.5,8.417.5,8.142C.5,7.5.5,6.854.5,6.21a.525.525,0,0,0-.079-.254C.285,5.74.14,5.532,0,5.321V4.414c.168-.249.339-.5.5-.749a.325.325,0,0,1,.3-.164c.3.006.6,0,.893,0,.206,0,.295.089.3.294,0,.424,0,.849,0,1.273,0,.053,0,.105,0,.168H2.49c0-.052.008-.1.008-.154q0-.593,0-1.186c0-.333.063-.4.389-.4.366,0,.732,0,1.1,0a.207.207,0,0,0,.2-.106c.253-.388.52-.767.765-1.16A.459.459,0,0,1,5.409,2c.385.014.771,0,1.157,0h.171V1.5H6.573c-.493,0-.986,0-1.479,0-.259,0-.344-.086-.345-.341q0-.41,0-.82c0-.253.089-.341.346-.341H9.914c.247,0,.337.091.338.334q0,.41,0,.82c0,.263-.084.347-.354.347-.483,0-.967,0-1.45,0H8.263V2h.165c.386,0,.772.01,1.157,0a.468.468,0,0,1,.468.246c.241.39.507.764.756,1.148a.219.219,0,0,0,.213.112c.469-.005.937,0,1.406,0,.235,0,.318.083.319.316,0,.551,0,1.1,0,1.666h.5v-.37c0-.259,0-.517,0-.776S13.334,4,13.58,4c.21,0,.42-.006.63,0a.349.349,0,0,1,.213.074c.2.192.386.4.577.6ZM3.008,8c.39,0,.77,0,1.15,0a.374.374,0,0,1,.352.187c.259.4.531.795.79,1.2a.244.244,0,0,0,.238.124q2.768,0,5.536,0h.165V4C11.1,4,10.964,4,10.833,4a.35.35,0,0,1-.339-.182c-.263-.4-.535-.8-.8-1.208A.222.222,0,0,0,9.483,2.5q-1.985,0-3.969,0a.222.222,0,0,0-.211.117c-.261.4-.532.794-.791,1.2A.381.381,0,0,1,4.148,4c-.332-.008-.664,0-1,0-.047,0-.094,0-.143.008Zm10.749.988c.221.032.426.051.568-.162.027-.04.076-.065.1-.105A.386.386,0,0,0,14.5,8.54q.006-1.791,0-3.583a.2.2,0,0,0-.025-.123c-.186-.214-.37-.442-.718-.307Zm-2,.506h.481V4.009H11.76ZM1.486,7.991V4.007c-.038,0-.067,0-.1,0A1.175,1.175,0,0,0,.9,4.022c-.13.068-.193.259-.293.39a.619.619,0,0,0-.114.349.966.966,0,0,0,.231.754,1.294,1.294,0,0,1,.185.28.7.7,0,0,1,.085.284C1,6.664,1,7.249,1,7.833v.158Zm3.767-7H9.744V.512H5.253Zm7.5,5.993h.478V6h-.478ZM7.742,1.512h-.48v.48h.48ZM2.011,6.241h.475V5.756H2.011Z",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_31636",
  "data-name": "Group 31636",
  transform: "translate(4.366 5.104)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_31625",
  "data-name": "Group 31625",
  transform: "translate(0 0)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_44154",
  "data-name": "Path 44154",
  d: "M.619,2.319a1.185,1.185,0,0,1-.451-.443A1.238,1.238,0,0,1,0,1.237,1.228,1.228,0,0,1,.167.6,1.189,1.189,0,0,1,.619.159,1.263,1.263,0,0,1,1.244,0a1.263,1.263,0,0,1,.625.159A1.164,1.164,0,0,1,2.317.6a1.248,1.248,0,0,1,.164.638,1.248,1.248,0,0,1-.165.639,1.176,1.176,0,0,1-.448.443,1.253,1.253,0,0,1-.624.159,1.263,1.263,0,0,1-.625-.159m1.089-.572a.733.733,0,0,0,.174-.51A.731.731,0,0,0,1.708.725.6.6,0,0,0,1.244.534a.6.6,0,0,0-.467.19A.73.73,0,0,0,.6,1.237a.731.731,0,0,0,.174.512.6.6,0,0,0,.467.191.594.594,0,0,0,.463-.193",
  transform: "translate(0 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_44155",
  "data-name": "Path 44155",
  d: "M11.355.12V.592h-.986V1.1h.737v.458h-.737v.979H9.78V.12Z",
  transform: "translate(-6.972 -0.086)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_44156",
  "data-name": "Path 44156",
  d: "M17.919.12V.592h-.986V1.1h.737v.458h-.737v.979h-.589V.12Z",
  transform: "translate(-11.651 -0.086)"
})))))), /*#__PURE__*/React.createElement("g", {
  id: "Group_31637",
  "data-name": "Group 31637",
  transform: "translate(77 -46)"
}, /*#__PURE__*/React.createElement("path", {
  id: "_378030ac88ef30f612d73644ecfa1025",
  "data-name": "378030ac88ef30f612d73644ecfa1025",
  d: "M9.783,10.261A2.253,2.253,0,1,0,7.467,8.009,2.285,2.285,0,0,0,9.783,10.261Zm0-3a.751.751,0,1,1-.772.751A.762.762,0,0,1,9.783,7.259Zm7.4,6.876a7.472,7.472,0,0,0-2-3.205A5.893,5.893,0,0,0,13.724,3.4a6.311,6.311,0,0,0-7.881,0A5.893,5.893,0,0,0,4.38,10.929a7.4,7.4,0,0,0-2.007,3.205,2.2,2.2,0,0,0,.363,1.974,2.339,2.339,0,0,0,1.876.908H14.955a2.339,2.339,0,0,0,1.868-.908A2.2,2.2,0,0,0,17.186,14.135ZM9.783,3.506a4.569,4.569,0,0,1,4.632,4.5,4.569,4.569,0,0,1-4.632,4.5,4.569,4.569,0,0,1-4.632-4.5,4.569,4.569,0,0,1,4.632-4.5Zm5.805,11.7a.779.779,0,0,1-.633.308H4.611a.779.779,0,0,1-.633-.308.734.734,0,0,1-.116-.653,5.858,5.858,0,0,1,1.451-2.417,6.3,6.3,0,0,0,8.939,0A5.858,5.858,0,0,1,15.7,14.555.734.734,0,0,1,15.588,15.208Z",
  transform: "translate(-3178.279 -3713.017)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_123",
  "data-name": "Line 123",
  y1: 15,
  x2: 15,
  transform: "translate(-3176 -3711)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeWidth: 2
}))))));

export default __webpack_public_path__ + "static/media/cut-off-power-when-low-battery.d4072ed9.svg";
export { SvgComponent as ReactComponent };